<template>
  <span class="info"><flag />{{ text }}</span>
</template>

<script>
import { Flag } from "@element-plus/icons";

export default {
  name: "Info",
  components: { Flag },
  props: {
    text: {
      type: String,
      default: "提示词",
    },
  },
  setup(props) {
    return {
      ...props,
    };
  },
};
</script>

<style scoped lang="scss">
.info {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: rgb(230, 126, 34);
  svg {
    width: 18px;
    margin-right: 4px;
  }
}
</style>
